export default __webpack_public_path__ + "static/media/algodao.c233f6a5.png";